import { Table } from '@mantine/core'
import styled from 'styled-components'
import { lgStyle } from '@/components/Adapter'

export const BaseCustomTableStyled = styled(Table)`
  width: 100%;
  overflow-x: auto;
  border-radius: 8px;
  z-index: 1;
  position: relative;

  div,
  p,
  span {
    white-space: nowrap;
  }

  .gui-table-thead-tr {
    height: 40px;
    background-color: var(--color-card-1);
  }

  .gui-table-th {
    white-space: nowrap;
    border-bottom: 0;
    color: var(--color-text-3);
    font-size: 14px;
    font-weight: 400;
    background-color: var(--color-card-1);
    padding: 0 6px;

    ${lgStyle} {
      padding: 0 12px;
    }

    &:first-of-type {
      padding: 0 6px 0 12px;

      ${lgStyle} {
        padding: 0 12px 0 24px;
      }
    }

    &:last-child {
      text-align: right;
      padding: 0 12px 0px 6px;

      ${lgStyle} {
        padding: 0 24px 0 12px;
      }
    }
  }

  .gui-table-tbody {
    width: 100%;
    position: relative;
  }

  .gui-table-tbody-tr {
    .gui-table-td {
      border-top: 0;
      height: 80px;
      background-color: var(--color-card-2);
      cursor: pointer;
      padding: 0 6px;

      ${lgStyle} {
        padding: 0 12px;
      }

      &:first-of-type {
        padding: 0 6px 0 12px;

        ${lgStyle} {
          padding: 0 12px 0 24px;
        }
      }
      &:last-child {
        padding: 0 12px 0px 6px;

        ${lgStyle} {
          padding: 0 24px 0 12px;
        }
      }
    }

    &:hover {
      background-color: var(--color-neutral-2);

      .gui-table-td {
        background-color: var(--color-neutral-2);
        z-index: 101 !important;
      }
    }
  }

  .gui-table-empty {
    width: 100%;
  }

  .gui-table-tfoot {
    background-color: var(--color-card-1);
    height: 48px;

    td {
      padding: 0 6px;

      ${lgStyle} {
        padding: 0 12px;
      }
    }

    td:first-of-type {
      padding: 0 6px 0 12px;

      ${lgStyle} {
        padding: 0 12px 0 24px;
      }
    }
    td:last-child {
      padding: 0 12px 0px 6px;

      ${lgStyle} {
        padding: 0 24px 0 12px;
      }
    }
  }

  &[data-ar='true'] {
    .gui-table-th {
      &:first-of-type {
        padding: 0 12px 0 6px;

        ${lgStyle} {
          padding: 0 24px 0 12px;
        }
      }

      &:last-child {
        text-align: left;
        padding: 0 6px 0px 12px;

        ${lgStyle} {
          padding: 0 12px 0 24px;
        }
      }
    }

    .gui-table-tbody-tr {
      .gui-table-td {
        &:first-of-type {
          padding: 0 12px 0 6px;
          ${lgStyle} {
            padding: 0 24px 0 12px;
          }
        }
        &:last-child {
          padding: 0 6px 0px 12px;
          ${lgStyle} {
            padding: 0 12px 0 24px;
          }
        }
      }
    }
  }
`

export const ScrollStyles = styled.div`
  overflow-y: auto;

  &::-webkit-scrollbar {
    width: 3px;
    height: 8px;
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 3px;
    background: hsla(215, 17%, 59%, 0.2);
  }

  &::-webkit-scrollbar-track {
    border-radius: 2px;
  }
`
